import { BzgModalRef } from 'bz-genome-angular';
import { Component } from '@angular/core';


@Component({
  selector: 'email-sent-dialog',
  templateUrl: './email-sent-dialog.component.html',
  styleUrls: ['../account-information.component.scss']
})
export class EmailSentDialogComponent  {
  
  constructor(public modalComponentRef: BzgModalRef) { }

  public close() {
    this.modalComponentRef.close();
  }
}
